import { FC } from 'react';
import { FlexBox, Tooltip, useIsMobile } from '@brg/ui';
import { ProjectTooltip } from '../tooltips';
import { MobileTooltipProps, ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { ReactComponent as MoreCircleSvg } from './assets/more-circle.svg';
import { ProjectEvents } from '../../helpers/projectEvents';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { ClickOutsideComponent } from '../CommentsController/components/ClickOutside';

export const BackdropContainer = styled(FlexBox)`
  justify-content: center;
  place-items: center;
  background: rgba(24, 26, 28, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 50%;
  height: 32px;
  width: 32px;
  min-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 24px;
    width: 24px;  
    min-width: 24px;
  }
`;

type PropsT = ProjectTooltipProps & ProjectEvents & MobileTooltipProps

export const ProjectCardTools: FC<PropsT> = (props) => {
  const isMobile = useIsMobile();

  const toggleVisible = () => {
    props?.toggleTooltip?.(!props?.tooltipOpen)
  }

  if (isMobile) {
    return (
      <ClickOutsideComponent onClose={() => props?.toggleTooltip(false)}>
        <div onClick={toggleVisible}>
          <Tooltip 
            // visible={props?.tooltipOpen} 
            placement={props?.placement} 
            target={<BackdropContainer><MoreCircleSvg /></BackdropContainer>}
          >
            <ProjectTooltip {...props} />
          </Tooltip>
        </div>
      </ClickOutsideComponent>
    )
  }

  return (
      <Tooltip 
        placement={props?.placement} 
        target={<BackdropContainer><MoreCircleSvg /></BackdropContainer>}
      >
        <ProjectTooltip {...props} />
      </Tooltip>
  )
}
import { FC } from 'react';
import { FlexBox, Tooltip, useIsMobile } from '@brg/ui';
import { ProjectTooltip } from '../tooltips';
import { MobileTooltipProps, ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { ReactComponent as MoreCircleSvg } from './assets/more-circle.svg';
import { ProjectEvents } from '../../helpers/projectEvents';
import styled from 'styled-components';
import { LayoutConst } from 'core';
import { ClickOutsideComponent } from '../CommentsController/components/ClickOutside';

export const BackdropContainer = styled(FlexBox)`
  justify-content: center;
  place-items: center;
  background: rgba(24, 26, 28, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 50%;
  height: 32px;
  width: 32px;
  min-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 24px;
    width: 24px;  
    min-width: 24px;
  }
`;

type PropsT = ProjectTooltipProps & ProjectEvents & MobileTooltipProps

export const ProjectCardTools: FC<PropsT> = (props) => {
  const isMobile = useIsMobile();

  const toggleVisible = () => {
    props?.toggleTooltip?.(!props?.tooltipOpen)
  }

  if (isMobile) {
    return (
      <ClickOutsideComponent onClose={() => props?.toggleTooltip(false)}>
        <div onClick={toggleVisible}>
          <Tooltip 
            // visible={props?.tooltipOpen} 
            placement={props?.placement} 
            target={<BackdropContainer><MoreCircleSvg /></BackdropContainer>}
          >
            <ProjectTooltip {...props} />
          </Tooltip>
        </div>
      </ClickOutsideComponent>
    )
  }

  return (
      <Tooltip 
        placement={props?.placement} 
        target={<BackdropContainer><MoreCircleSvg /></BackdropContainer>}
      >
        <ProjectTooltip {...props} />
      </Tooltip>
  )
}
